module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7yXJN"))).then(() => parcelRequire('5erN3'));